// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"c672bf63","496":"119d71e1","667":"ab110520","862":"f781c5ec","879":"5e40bef3","987":"72ac7527"}[chunkId] + ".chunk.js";
};